import { req   , reqPostWithData, contentTYPE_JSON } from './axiosCreator'

const UserService = "/UserService"

// /web/api/UserService/login
//登录
export const login = ( params ) => { return req( 'get', UserService+"/login" + params )}

// /web/api/UserService/getAllUser/{pageNum}/{pageSize}/{fromStat}/{toStat} 
//获取特定用户列表
export const getAllUser = ( params ) =>{ return req( 'get', UserService+"/getAllUser" + '/' + params )}

// /web/api/UserService/getCurrentUser
//获取当前用户
export const getCurrentUser = () =>{ return req( 'get', UserService+"/getCurrentUser" )}

// /web/api/UserService/getCurrentUserByToken
//获取当前用户
export const getCurrentUserByToken = () =>{ return req( 'get', UserService+"/getCurrentUserByToken" )}

// /web/api/UserService/getUser/{teleNum}
//获取特定用户
export const getUser = ( params ) =>{ return req( 'get', UserService+"/getUser" + '/' + params )}

// /web/api/UserService/getUserAfterExam/{teleNum}
//获取用户预后信息
export const getUserAfterExam = ( params ) =>{ return req( 'get', UserService+"/getUserAfterExam" + '/' + params )}


export const getUserAllExam = ( params ) =>{ return req( 'get', UserService+"/getUserAllExam" + '/' + params )}
///web/api/UserService/getUserBookedResource/{teleNum}
//获取用户预约的资源
export const getUserBookedResource = ( params ) =>{ return req( 'get', UserService+"/getUserBookedResource" + '/' + params )}

// /web/api/UserService/getUserExam/{teleNum}
//获取用户检测信息
export const getUserExam = ( params ) =>{ return req( 'get', UserService+"/getUserExam" + '/' + params )}

// /web/api/UserService/getUserInfo/{teleNum}
//通过手机号码获取用户基本信息。
export const getUserInfo = ( params ) =>{ return req( 'get', UserService+"/getUserInfo" + '/' + params )}

///web/api/UserService/getUserMedHistory/{teleNum}
//获取用户病史
export const getUserMedHistory= ( params ) =>{ return req( 'get', UserService+"/getUserMedHistory" + '/' + params )}

///web/api/UserService/cancelBookedResource/{teleNum}
// 取消预约
export const cancelBookedResource= ( params ) =>{ return req( 'get', UserService+"/cancelBookedResource" + "/" + params )}

///web/api/UserService/searchUser/{pageNum}/{pageSize}
//查询用户
export const searchUser = (params, data ) => { return req('get',  UserService + "/searchUser" + "/" + params ,  data) }

//POST
//通过手机号码+密码登录，只对工作人员有效。
export const loginWithPwd = ( params ) =>{ return req( 'post', UserService+"/loginWithPwd" , params )}

//通过手机验证码注册并登录。（只对一般客户有效）
export const loginWithVerifyCode = ( params ) =>{ return reqPostWithData( 'post', UserService+"/loginWithVerifyCode" , params )}

//登出
export const logout = (  ) =>{ return req( 'get', UserService+"/logout" )}

//更新用户预后信息
export const updateUserAfterExam = ( params ) =>{ return req( 'post', UserService+"/updateUserAfterExam" , params , contentTYPE_JSON)}

//更新用户检测信息
export const updateUserExam = ( params ) =>{ return req( 'post', UserService+"/updateUserExam" , params , contentTYPE_JSON)}

//更新用户基本信息
export const updateUserInfo = ( params ) =>{ return req( 'post', UserService+"/updateUserInfo" , params ,contentTYPE_JSON)}

//更新用户病史
export const updateUserMedHistory = ( params ) =>{ return req( 'post', UserService+"/updateUserMedHistory" , params ,contentTYPE_JSON)}

//预约一次检查
// export const bookMedResource = ( params ) =>{ return reqJSON( 'post', UserService+"/bookMedResource" , params )}

export const bookMedResource = ( teleNum, params ) =>{ return req( 'post', UserService+"/bookMedResource" + "/" + teleNum , params , contentTYPE_JSON)}


